




















import { defineComponent, PropType } from "@vue/composition-api";
import { OnboardingItem } from "@/const";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "OnboardingListItem",
  components: { BaseIcon },
  props: {
    item: { type: Object as PropType<OnboardingItem>, required: true },
  },
});
